import ChatInterface from "../components/gen-ai-widget/ChatInterface";

const GenAIWidget = () => {
  return (
    <div className="p-20 d-flex align-items-center justify-content-center tw-h-full tw-w-full tw-overflow-hidden">
      <ChatInterface />
    </div>
  );
};

export default GenAIWidget;
